export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/6K4jc5pfj9cNnj1FirPo18/IMG_2773.jpg',
    alt: 'Volume 1 cover: Electric Motor Fundamentals, Construction & Ratings, showing a motor coupled to a pump',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3HKTdG3iXtnAEgQaVLCuMH/IMG_2774.jpg',
    alt: 'Sample page Every Part of the Motor Has a Job: exploded anatomy of a three-phase induction motor',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gUh7kaCLxbaYgNNEgSwB4C/IMG_2775.jpg',
    alt: 'Sample page Swap Two Phases, Reverse the Motor: phase sequence and rotation direction',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/uknpkhaP9gf3cr3CYWye3S/IMG_2776.jpg',
    alt: 'Sample page Brushless Motors Use Electronics Instead of a Commutator: brushless DC and EC motors',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dmTfKgZR3fjcA6k2DnDg67/IMG_2777.jpg',
    alt: 'Sample page Isolate, Lock, Prove, Then Work: basic motor isolation sequence',
  },
];
